var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-payment"},[_c('Overlay',{attrs:{"width":"x-small","autoHeight":"","link":_vm.closeLink}},[_c('SubscriptionInfo',{attrs:{"site":_vm.site,"companyId":_vm.companyId,"siteId":_vm.siteId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }